import { render, staticRenderFns } from "./ClientSockets.vue?vue&type=template&id=38772079&scoped=true"
import script from "./ClientSockets.vue?vue&type=script&lang=js"
export * from "./ClientSockets.vue?vue&type=script&lang=js"
import style0 from "./ClientSockets.vue?vue&type=style&index=0&id=38772079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38772079",
  null
  
)

export default component.exports